<template>
  <div>
    <FormDialog :title="title" :isShow.sync="isShow" width="690px" v-on:resetForm="close()">
      <div class="home land-form" style="padding: 0px 100px;">
      <el-form ref="form" :model="form" label-width="80px" :rules="rules" size="small">
          <el-form-item label="用户姓名" prop="applyName">
            <el-input v-model="form.applyName"></el-input>
          </el-form-item>
          <el-form-item label="用户性别" prop="userSex">
            <el-select v-model="form.userSex">
              <el-option label="男" value="0"></el-option>
              <el-option label="女" value="1"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="单位名称" prop="userAddress">
            <el-select v-model="form.userAddress">
              <el-option
                v-for="(item,index) in companys"
                v-bind:value="item.companyname"
                v-text="item.companyname"
                :command="item"
                :key="'header'+ index"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="用户账号" prop="account">
            <el-input v-model="form.account"></el-input>
          </el-form-item>
          <el-form-item label="用户类型" prop="registerType">
            <el-select v-model="form.registerType">
              <el-option label="普通用户" value="0"></el-option>
              <el-option label="审核用户" value="1"></el-option>
              <el-option label="管理员用户" value="2"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="手机号码" prop="registerPhone">
            <el-input v-model="form.registerPhone"></el-input>
          </el-form-item>
          <!--<el-form-item label="用户邮箱">
            <el-input v-model="form.userEmail"></el-input>
          </el-form-item>-->
        </el-form>
      </div>
      <template v-slot:footer>
        <el-button type="primary" @click="submit()" size="small">保存</el-button>
        <el-button @click="isShow=false" size="small">关闭</el-button>
      </template>
    </FormDialog>
  </div>
</template>
<script>
import FormDialog from '@/components/dialog/formDialog'
import { userInfoApi } from '@/api/managementSystemApi'
import { Notification } from 'element-ui'

export default {
  name: 'editUser',
  components: {
    FormDialog
  },
  data() {
    return {
      isShow: false,
      title: '编辑',
      form: {},
      rules: {
        applyName: [{ required: true, message: '请输入用户姓名', trigger: 'blur' }],
        userSex: [{ required: true, message: '请选择用户性别', trigger: 'change' }],
        userAddress: [{ required: true, message: '请选择所在公司', trigger: 'change' }],
        account: [{ required: true, message: '请输入用户名', trigger: 'blur' },
          { validator: this.$validRule.checkUser, trigger: 'blur' }
        ],
        registerType: [{ required: true, message: '请选择用户类型', trigger: 'change' }],
        registerPhone: [
          { required: false, message: '请输入手机号码', trigger: 'blur' },
          { validator: this.$validRule.checkMobile, trigger: 'blur' }
        ],
        userEmail: [
          { required: false, message: '请输入邮箱', trigger: 'blur' }
        ]},
      wtUploadList: [],
      tableList: [],
      companys: []
    }
  },
  methods: {
    open(rowData) {
      if (rowData !== undefined) {
        this.form = rowData
      }
      this.isShow = !this.isShow
      const params = {
        pageNo: 0,
        pageSize: 0,
        params: [
          {
            column: '',
            type: '',
            val: ''
          }
        ]
      }
      userInfoApi.selectCompany(params).then(response => {
        if (response.code === '200') {
          const data = response.data
          this.companys = data
        }
      })
      this.title = '编辑'
      if (this.form.userSex == '0') {
        this.form.userSex = '男'
      } else {
        this.form.userSex = '女'
      }
      if (this.form.registerType == '0') {
        this.form.registerType = '普通用户'
      } else if (this.form.registerType == '1') {
        this.form.registerType = '审核用户'
      } else if (this.form.registerType == '2') {
        this.form.registerType = '管理员用户'
      }
    },

    submit() {
      const _this = this
      this.$refs.form.validate(valid => {
        if (valid) {
          // 用户信息添加到数据库
          if (_this.form.userSex === '男') {
            _this.form.userSex = 0
          } else {
            _this.form.userSex = 1
          }
          if (this.form.registerType == '普通用户') {
            this.form.registerType = 0
          } else if (this.form.registerType == '审核用户') {
            this.form.registerType = 1
          } else if (this.form.registerType == '管理员用户') {
            this.form.registerType = 2
          }
          userInfoApi.updateUser(_this.form).then(res => {
            if (res.code === '200' && res.data !== '此用户账号已存在！') {
              _this.$utils.success('保存成功！')
              this.$emit('refreshData')
              this.close()
            } else if (res.data === '此用户账号已存在！') {
              _this.$utils.error('保存失败！此用户账号已存在！')
            } else {
              _this.$utils.error('保存失败！原因是：' + res.msg)
            }
          })
        } else {
          return false
        }
      })
    },
    close() {
      this.$refs.form.resetFields()
      this.form = {}
      this.wtUploadList = []
      this.isShow = false
      this.tableList = []
      // this.$emit("refreshData")
    }
  }
}
</script>
<style lang="scss" scoped>
.land-form {
  table {
    width: 100%;
    border-collapse: collapse;
    border-spacing: 0;

    tr {
      td {
        font-size: 16px;
        color: #333333;
        border: 1px solid #dddddd;
        padding: 6px 10px;

        .upload-button-left {
          margin-right: 10px;

          ::v-deep {
            .el-button.el-button--small,
            .el-button--small.is-round {
              font-size: 14px;
              padding: 8px 15px;

              i.iconfont {
                font-size: 14px;
                margin-right: 5px;
              }
            }
          }
        }

        .el-button.el-button--small,
        .el-button--small.is-round {
          font-size: 14px;
          padding: 8px 15px;

          i.iconfont {
            font-size: 14px;
            margin-right: 5px;
          }
        }

        .el-form-item--mini.el-form-item,
        .el-form-item--small.el-form-item {
          margin-bottom: 0px;
        }

        .el-date-editor.el-input,
        .el-date-editor.el-input__inner {
          width: 100%;
        }

        &:nth-child(even) {
          background: #fff;
        }

        &:nth-child(odd) {
          background: #f5f6f8;
          text-align: right;
        }

        &.header {
          height: 40px;
          background: #f0f6fa;
          padding: 0px 10px;
          text-align: left;
          font-weight: bold;
        }

        .img-list {
          position: relative;
          width: 124px;
          height: 71px;
          margin-right: 10px;
          display: inline-block;
          vertical-align: middle;

          img {
            width: 100%;
            height: 100%;
          }

          .img-detele {
            position: absolute;
            bottom: 0px;
            width: 100%;
            height: 20px;
            background: rgba(0, 0, 0, 0.5);
            line-height: 20px;
            color: #fff;
            text-align: center;
            cursor: pointer;
          }
        }

        .add-img {
          cursor: pointer;
          display: inline-block;
          vertical-align: middle;
          ::v-deep {
            > div {
              line-height: normal;
              .el-upload-dragger {
                height: 100%;
                width: 100%;
                font-size: 14px;
                color: #666666;
                padding: 5px 0px 4px;
                width: 124px;
                height: 71px;
                .el-icon-upload {
                  color: #2f77f1;
                  font-size: 22px;
                  margin: 0px;
                  line-height: 20px;
                }
              }
            }
          }
        }

        .tabs {
          .tabs-label {
            display: flex;
            justify-content: center;
            padding: 0px 20px;
            background: #f5f6f8;
            height: 47px;
            line-height: 47px;
            padding-top: 5px;
            border-bottom: 1px solid #ddd;

            > div {
              width: calc(100% / 6);
              text-align: center;
              height: 43px;
              line-height: 43px;
              cursor: pointer;
              border: 1px solid transparent;

              &.active {
                background: #fff;
                border-right: 1px solid #ddd;
                border-left: 1px solid #ddd;
                border-top: 1px solid #ddd;
                border-bottom: 1px solid #fff;
              }
            }
          }

          .tabs-content {
            padding: 20px;
            text-align: left;

            .el-button {
              margin-bottom: 10px;
            }

            table {
              width: 100%;

              th {
                height: 40px;
                background: #f8f8f9;
                font-size: 16px;
                font-weight: 600;
                color: #515a6e;
                text-align: left;

                &:first-child {
                  text-align: center;
                }
              }

              td {
                height: 48px;
                background: #ffffff;
                font-size: 16px;
                font-weight: 400;
                color: #333333;
                text-align: left;
                border: none;
                border-bottom: 1px solid #ddd;

                &:first-child {
                  text-align: center;
                }
              }
            }
          }
        }
      }
    }
  }

  .el-select {
    width: 100%;

    ::v-deep {
      .el-input-number {
        .el-input__inner {
          text-align: left;
        }
      }
    }
  }
}
</style>
